import { render, staticRenderFns } from "./StudentsByCourseInstructor.vue?vue&type=template&id=776831ac&scoped=true&"
import script from "./StudentsByCourseInstructor.vue?vue&type=script&lang=js&"
export * from "./StudentsByCourseInstructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776831ac",
  null
  
)

export default component.exports